const DURATION = 700;

export default () => ({
  shown: false,
  target: 0,
  start: 0,
  updateCounter(currentTime) {
    const elapsedTime = currentTime - this.startTime;
    const progress = Math.min(elapsedTime / DURATION, 1);
    const currentValue = Math.floor(
      this.start + (this.target - this.start) * progress
    );
    this.$refs.target.textContent = currentValue;

    if (progress < 1) {
      requestAnimationFrame(this.updateCounter.bind(this));
    }
  },
  animateCounter() {
    this.start = 0;
    this.startTime = performance.now();
    requestAnimationFrame(this.updateCounter.bind(this));
  },
  init() {
    this.target = parseInt(this.$refs.target.textContent, 10);
    this.$watch('shown', (value) => {
      if (value) {
        this.animateCounter();
      }
    });
  },
});
